import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import { observer } from "mobx-react";
import { RouteComponentProps } from "react-router";
import { IPageBreadCrumbsTag, PageBreadcrumbs } from "Views/Components/Breadcrumbs/PageBreadcrumbs";
import AccessIntelSecuredPage from "Views/Components/Security/AccessIntelSecuredPage";
import Tabs, { ITabConfig } from "Views/Components/Tabs/Tabs";
import { CustomerApplicationOverviewTab } from "./CustomerApplicationTabs/CustomerApplicationOverviewTab";
import { CustomerApplicationBusinessInfoTab } from "./CustomerApplicationTabs/CustomerApplicationBusinessInfoTab";
import { CustomerApplicationAdverseAlertTab } from "./CustomerApplicationTabs/CustomerApplicationAdverseAlertTab";
import { CustomerApplicationDetailPageTabKeys, CustomerApplicationDetailProvider, useCustomerApplicationDetailContext } from "./CustomerApplicationDetailPageContext";
import InlineSpinner from "Views/Components/Spinner/InlineSpinner";
import { CustomerApplicationCreditReportTab } from "./CustomerApplicationTabs/CustomerApplicationCreditReportTab";
import { ApplicationSummaryTab } from "./CustomerApplicationTabs/ApplicationSummaryTab";

function getBreadcrumbTags(model: CustomerApplicationSummary): IPageBreadCrumbsTag[] {
	return [
		{
			label: "Customer Applications",
			link: '/approve/customerapplications'
		},
		{
			label: `${model.businessInformation.businessName ? model.businessInformation.businessName : model.legacyId}`,
		}
	]
}

interface CustomerApplicationDetailPageRouteParams {
	id: string;
}

export interface CustomerApplicationDetailPageProps extends RouteComponentProps<CustomerApplicationDetailPageRouteParams> {

}

const CustomerApplicationDetailPage = observer((props: CustomerApplicationDetailPageProps) => {

	const { id } = props.match.params;

	return (
		<CustomerApplicationDetailProvider id={id}>
			<AccessIntelSecuredPage routeComponentProps={props} product="approve">
				<div className="body-content">
					<div className="invisible-page-wrap customer-application-detail-page">
						<CustomerApplicationDetailPageContents />
					</div>
				</div>
			</AccessIntelSecuredPage>
		</CustomerApplicationDetailProvider>
	);
})

export default CustomerApplicationDetailPage;

const CustomerApplicationDetailPageContents = () => {

	const {
		model,
		currentTab,
		setCurrentTab
	} = useCustomerApplicationDetailContext();


	if (!model) return <InlineSpinner />

	const tabs: ITabConfig[] = [
		{
			name: "Overview",
			key: "overview",
			component: <CustomerApplicationOverviewTab />,
		},
		{
			name: "Business Info",
			key: "business-info",
			component: <CustomerApplicationBusinessInfoTab businessName={model.businessInformation.businessName ?? ""} />,
		},
		{
			name: "Application Summary",
			key: "application-summary",
			component: <ApplicationSummaryTab />
		},
		// { 
		// name: "PPSR Registration",
		// key: "ppsr-reg",
		// component: <CustomerApplicationPpsrRegTab />
		// },
		{
			name: "Adverse Alerts",
			key: "adverse-alerts",
			component: <CustomerApplicationAdverseAlertTab />
		},
		{
			name: "Credit Report",
			key: "credit-report",
			component: <CustomerApplicationCreditReportTab />
		}
		// FUTURE: Other tabs
	];

	return (
		<>
			<PageBreadcrumbs tags={getBreadcrumbTags(model)} />
			<div className="white-box">
				<Tabs
					tabs={tabs}
					currentTab={currentTab}
					onTabClicked={(key, event) => setCurrentTab(key as CustomerApplicationDetailPageTabKeys)}
				/>
			</div>
		</>
	);
};


